// extracted by mini-css-extract-plugin
export default {"headerHeight":"de5yb","content":"kkAAB"};